// Generated by Melange

import * as Dom from "@floating-ui/dom";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as $$Promise from "../promise/promise.jsx";
import * as Stdlib__Float from "melange/float.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Webapi__Dom__Element from "melange-webapi/Webapi/Dom/Webapi__Dom__Element.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const context = React.createContext(undefined);

const make = context.Provider;

function use(param) {
  return Stdlib__Option.get(React.useContext(context));
}

const Context = {
  context: context,
  make: make,
  use: use
};

function Popover$Root(Props) {
  let children = Props.children;
  const match = React.useState(function () {
    return Stdlib__Fun.$$const(undefined, undefined);
  });
  const setReference = match[1];
  const reference = match[0];
  const value = React.useMemo((function () {
    return {
      reference: reference,
      setReference: setReference
    };
  }), [reference]);
  return JsxRuntime.jsx(make, {
    value: value,
    children: children
  });
}

const Root = {
  make: Popover$Root
};

function Popover$Reference(Props) {
  let children = Props.children;
  const context$1 = Stdlib__Option.get(React.useContext(context));
  return React.cloneElement(children, {
    ref: context$1.setReference
  });
}

const Reference = {
  make: Popover$Reference
};

function Popover$Content(Props) {
  let children = Props.children;
  let mainAxisOffset = Props.mainAxisOffset;
  let padding = Props.padding;
  let placement = Props.placement;
  let strategyOpt = Props.strategy;
  const strategy = strategyOpt !== undefined ? strategyOpt : "absolute";
  const match = React.useState(function () {
    return Stdlib__Fun.$$const(undefined, undefined);
  });
  const setFloating = match[1];
  const floating = match[0];
  const match$1 = Stdlib__Option.get(React.useContext(context));
  const reference = match$1.reference;
  const match$2 = React.useState(function () {
    return Stdlib__Fun.$$const(false, undefined);
  });
  const setIsOpen = match$2[1];
  const isOpen = match$2[0];
  const match$3 = React.useState(function () {
    return Stdlib__Fun.$$const(undefined, undefined);
  });
  const setStyle = match$3[1];
  const updateStyle = React.useCallback((function (param) {
    if (!isOpen) {
      return Curry._1(setStyle, (function (param) {
        return Stdlib__Fun.$$const(undefined, param);
      }));
    }
    if (floating === undefined) {
      return Curry._1(setStyle, (function (param) {
        return Stdlib__Fun.$$const(undefined, param);
      }));
    }
    if (reference === undefined) {
      return Curry._1(setStyle, (function (param) {
        return Stdlib__Fun.$$const(undefined, param);
      }));
    }
    let tmp = {};
    if (mainAxisOffset !== undefined) {
      tmp.mainAxis = Caml_option.valFromOption(mainAxisOffset);
    }
    let tmp$1 = {};
    if (padding !== undefined) {
      tmp$1.padding = Caml_option.valFromOption(padding);
    }
    let tmp$2 = {};
    if (padding !== undefined) {
      tmp$2.padding = Caml_option.valFromOption(padding);
    }
    const middleware = [
      Dom.offset(tmp),
      Dom.flip(tmp$1),
      Dom.shift(tmp$2),
      Dom.size({
        apply: (function (param) {
          const style = Stdlib__Option.map((function (prim) {
            return prim.style;
          }), Webapi__Dom__Element.asHtmlElement(param.elements.floating));
          if (style === undefined) {
            return;
          }
          const style$1 = Caml_option.valFromOption(style);
          const setProp = function (name, value) {
            style$1.setProperty(name, value, "");
          };
          setProp("max-width", Stdlib__Float.to_string(Math.max(0.0, param.availableWidth)) + "px");
          setProp("max-height", Stdlib__Float.to_string(Math.max(0.0, param.availableHeight)) + "px");
        })
      })
    ];
    let tmp$3 = {
      middleware: middleware,
      strategy: strategy
    };
    if (placement !== undefined) {
      tmp$3.placement = (function () {
        switch (placement) {
          case "topEnd" :
            return "top-end";
          case "bottomEnd" :
            return "bottom-end";
        }
      })();
    }
    const options = tmp$3;
    $$Promise.Monad_syntax.let$star(Dom.computePosition(Caml_option.valFromOption(reference), Caml_option.valFromOption(floating), options), (function (param) {
      const partial_arg = {
        position: strategy,
        left: param.x,
        top: param.y,
        visibility: undefined
      };
      Curry._1(setStyle, (function (param) {
        return Stdlib__Fun.$$const(partial_arg, param);
      }));
      return Promise.resolve(undefined);
    }));
  }), [
    floating,
    isOpen,
    mainAxisOffset,
    padding,
    placement,
    reference,
    strategy
  ]);
  React.useEffect((function () {
    Curry._1(updateStyle, undefined);
    if (isOpen && floating !== undefined && reference !== undefined) {
      return Dom.autoUpdate(Caml_option.valFromOption(reference), Caml_option.valFromOption(floating), (function () {
        return Curry._1(updateStyle, undefined);
      }));
    }
    
  }), [
    floating,
    isOpen,
    reference,
    updateStyle
  ]);
  const childrenProps = children.props;
  React.useEffect((function () {
    Stdlib__Option.iter((function (x) {
      x.addEventListener("toggle", (function ($$event) {
        const isOpen = $$event.newState === "open";
        Curry._1(setIsOpen, (function (param) {
          return Stdlib__Fun.$$const(isOpen, param);
        }));
        Stdlib__Option.iter((function (onToggle) {
          Curry._1(onToggle, $$event);
        }), childrenProps.onToggle);
      }), {});
    }), floating);
  }), [floating]);
  const arg = {
    top: undefined,
    left: undefined,
    position: undefined,
    visibility: "hidden"
  };
  return React.cloneElement(children, {
    ref: (function (node) {
      Curry._1(setFloating, (function (param) {
        return node;
      }));
      Stdlib__Option.iter((function (ref) {
        ref.current = node;
      }), childrenProps.ref);
    }),
    style: Object.assign(Object.assign({
      visibility: undefined
    }, childrenProps.style), (function (param) {
      return Stdlib__Option.value(param, arg);
    })(match$3[0]))
  });
}

const Content = {
  make: Popover$Content
};

export {
  Context,
  Root,
  Reference,
  Content,
}
/* context Not a pure module */
